import { dispatchMetadataEvent } from "../metadata-history/dispatch";
import { applyMetadataEvent, type MetadataEventPayload } from "../metadata-history/metadata-events";
import { ArtMetadataSchema, type ArtTextStyle } from "../schedule-presets/art-metadata";
import { builderSessionId } from "../../stores/metadata-builder-store";
import { useMetadataHistoryStore } from "../../stores/metadata-history-store";

export function dispatchBuilderMetadata(payload: MetadataEventPayload, mergeKey?: string) {
  const metadata = useMetadataHistoryStore.getState().sessions[builderSessionId]?.projection;
  if (!metadata) return;
  const next = applyMetadataEvent(metadata, payload);
  if (!ArtMetadataSchema.safeParse(next).success) return;
  dispatchMetadataEvent(payload, mergeKey);
}

export function setBuilderTextStyle(name: string, patch: Partial<ArtTextStyle>, field: keyof ArtTextStyle, merge = false) {
  const metadata = useMetadataHistoryStore.getState().sessions[builderSessionId]?.projection;
  const current = metadata?.styles[name];
  if (!metadata || !current) return;
  const style = { ...current, ...patch };
  if (!style.stroke) delete style.stroke;
  const mergeKey = merge ? `style:${name}:${field}` : undefined;
  dispatchBuilderMetadata({ type: "style/set", name, style, field }, mergeKey);
}
